import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {

  constructor(public httpClient: HttpClient) { }

  mountUrlResized(url: string): string{
    let fullUrl = url.split('/');
    let filename = fullUrl.pop();
    const basePath = "https://blukitfotosprodutos.s3.sa-east-1.amazonaws.com/resources/";
    const width = 200;
    const heigth = 200;
    const proportional = 1;
    let urlResized = basePath + filename + width + "-" + heigth + "p%3A" + proportional + ".jpg"

    return urlResized;
  }

  verifyExistyUrlResized(url: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let image = new Image();
      image.onload = function () {
        if (image.width > 0 && image.height > 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      };

      image.onerror = function() {
        console.error('Link inválido. A imagem não pôde ser carregada. Url: ' + url);
        resolve(false);
      };
      image.src = url;
    });
  }


  async requestUrlResized(url: string) {
    const baseUrl = "https://blukitsiteadm.mobilesales.com.br/tools/tools-image-resize";
    const width = 200;
    const heigth = 200;
    const proportional = 1;
    const base64 = 0;
    const renew = 0;

    const urlRequest = `${baseUrl}?image_url=${url}&image_width=${width}&image_height=${heigth}&proportional=${proportional}&base64=${base64}&renew=${renew}`;

    let urlResized;

    urlResized = await fetch(urlRequest).then(response => response.json()).then(data => {
      return data.newurl;
    })

    return urlResized ? urlResized : '';

  }

  async getUrlResized(url:string){
    let urlResized = this.mountUrlResized(url);
    if(await this.verifyExistyUrlResized(urlResized)){
      return urlResized;
    }
    urlResized = await this.requestUrlResized(url);
    return urlResized;
  }

}
